import { FC } from 'react'

import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import Logo from 'src/Assets/logo.svg?react'
import { Input } from 'src/Components/Input/index.tsx'
import { Button } from 'src/Components/Button'
import { RoutesEnum } from 'src/Router/types'
import { useLoginMutation } from 'src/Redux/api/authApi'
import { setCredentials } from 'src/Redux/auth-process/authSlice'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
  margin: 0 auto;
  height: 100vh;
`

const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

export const LoginPage: FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [login, { isLoading, error }] = useLoginMutation()

  const { control, handleSubmit } = useForm<{
    email: string
    password: string
  }>({
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onLoginClick = async (data: {
    email: string
    password: string
  }): Promise<void> => {
    try {
      const result = await login(data).unwrap()
      dispatch(setCredentials({ user: result.user, token: result.token }))
      navigate(RoutesEnum.TRANSPORTS)
    } catch {
      // Ошибки обрабатываются RTK Query и отображаются в интерфейсе
    }
  }

  return (
    <Container>
      <Logo />
      <FormWrapper onSubmit={handleSubmit(onLoginClick)}>
        <Controller
          name='email'
          control={control}
          render={({ field: { onChange, value } }) => (
            <Input
              placeholder={'Email пользователя'}
              value={value}
              onChange={onChange}
              label={'Email'}
            />
          )}
        />

        <Controller
          name='password'
          control={control}
          render={({ field: { onChange, value } }) => (
            <Input
              placeholder={'Пароль пользователя'}
              value={value}
              onChange={onChange}
              label={'Пароль'}
              type={'password'}
            />
          )}
        />

        <Button type='submit' disabled={isLoading}>
          {isLoading ? 'Вход...' : 'Войти'}
        </Button>
        {error ? (
          <div style={{ color: 'red', textAlign: 'center' }}>
            Ошибка входа. Проверьте email и пароль.
          </div>
        ) : null}
      </FormWrapper>
    </Container>
  )
}
